import { useMemo } from 'react';
import { buildAvailableForms } from '../../../../utils/formDisplayNames';

/**
 * Hook to generate available forms from portfolio and properties.
 * Delegates to the shared buildAvailableForms() utility so form names
 * are consistent with QR Generator, Form Responses, and every other module.
 *
 * @param {Object} portfolio  - Return value of usePortfolioData()
 * @param {Array}  properties - Array of property documents
 * @returns {Array} - Array of { id, name, type, propertyId? }
 */
const useAvailableForms = (portfolio, properties) => {
    return useMemo(
        () => buildAvailableForms(portfolio, properties),
        [portfolio, properties],
    );
};

export default useAvailableForms;
